import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit, Renderer2, ViewChild } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { GeneralService } from 'src/app/Service/general.service';
import { AddCallAlertFormComponent } from '../add-call-alert-form/add-call-alert-form.component';
import { MatDialog } from '@angular/material';
import * as moment from 'moment';
import { DaterangepickerComponent } from 'ng2-daterangepicker';

class DataTablesResponse {
    data: any[];
    draw: number;
    recordsFiltered: number;
    recordsTotal: number;
}

@Component({
    selector: 'app-daily-call-alert-report',
    templateUrl: './daily-call-alert-report.component.html',
    styleUrls: ['./daily-call-alert-report.component.scss'],
})
export class DailyCallAlertReportComponent implements OnInit {
    breadCrumbItems: Array<{}>;
    usersData: any;
    userId: any;
    public daterange: any = {};
    dates: { endDate: string; startDate: string };
    callAlertTypes: any[] = [];
    dtOptions: DataTables.Settings = {};
    @ViewChild(DataTableDirective, { static: false })
    dtElement: DataTableDirective;
    @ViewChild(DaterangepickerComponent, { static: false })
    picker: DaterangepickerComponent;
    dtTrigger = new Subject<any>();
    isLoading: boolean = false;
    isshow: boolean = false;
    currentUser: any;
    date: any = new Date();
    @Input() Type: string;
    myGroup: FormGroup;
    dateRangeValue: string;
    /** ng2-daterangepicker options: calendar opens on today's date by default */
    options: any = {
        opens: 'left',
        autoUpdateInput: false,
        startDate: moment(),
        endDate: moment(),
    };

    constructor(
        private service: GeneralService,
        private http: HttpClient,
        private datePipe: DatePipe,
        private dialog: MatDialog,
        private rerender2: Renderer2
    ) {}

    ngOnInit() {
        this.currentUser = this.service.getcurrentUser();
        this.myGroup = new FormGroup({
            date: new FormControl(null),
        });
        // Date filter is always pre-selected with today's date
        this.setDateRangeToToday();
        this.dtOptions = {
            pagingType: 'simple_numbers',
            pageLength: 10,
            processing: true,
            serverSide: true,
            ordering: false,
            searching: false,
            ajax: (dataTablesParameters: any, callback) => {
                this.isLoading = true;
                this.http
                    .get<DataTablesResponse>(
                        `${this.service.CallDate()}${
                            (dataTablesParameters.start +
                                dataTablesParameters.length) /
                            dataTablesParameters.length
                        }/${
                            dataTablesParameters.length.value != ''
                                ? +dataTablesParameters.length
                                : ''
                        }` +
                            `${
                                this.dates
                                    ? '/' +
                                      this.dates.startDate +
                                      '/' +
                                      this.dates.endDate
                                    : ''
                            }`
                    )
                    .subscribe((resp: any) => {
                        if (resp.total_count) {
                            callback({
                                recordsTotal: resp.total_count,
                                recordsFiltered: resp.total_count,
                                data: resp.data,
                            });
                            this.isLoading = false;
                        } else {
                            callback({
                                recordsTotal: resp.total_count,
                                recordsFiltered: resp.total_count,
                                data: resp.data,
                            });
                            this.isLoading = false;
                        }
                    });
            },
            responsive: true,
            columns: [
                {
                    title: 'User ID',
                    data: null,
                    render: (data) => {
                        return this.renderData(data.user_id);
                    },
                },
                {
                    title: 'User Name',
                    data: null,
                    render: (data) => {
                        return this.renderData(data.UserName);
                    },
                },
                {
                    title: 'Mobile Number',
                    data: null,
                    render: (data) => {
                        return this.renderData(data.MobileNo);
                    },
                },
                {
                    title: 'Alert Type',
                    data: null,
                    render: (data) => {
                        return this.renderData(data.alert_type);
                    },
                },
                {
                    title: 'Call Initiated From',
                    data: null,
                    render: (data) => {
                        return this.renderData(data.call_initiated_from);
                    },
                },
                {
                    title: 'Call Type',
                    data: null,
                    render: (data) => {
                        return this.renderData(data.call_type);
                    },
                },
                {
                    title: 'Activation Status',
                    data: null,
                    render: (data) => {
                        return this.renderData(data.activation_status);
                    },
                },
                {
                    title: 'Last Call Date And Time',
                    data: null,
                    render: (data) => {
                        return this.renderDateTime(data.call_date);
                    },
                },
                {
                    title: 'Next Follow up Date',
                    data: null,
                    render: (data) => {
                        return this.renderDateTime(data.follow_up_date);
                    },
                },
                {
                    title: 'Called By',
                    data: null,
                    render: (data) => {
                        return this.renderData(data.csrName);
                    },
                },
                // {
                //   title: 'Remarks',
                //   name: null,
                //   data: null,
                //   render: (data) => {
                //     return data.call_remarks;
                //   }
                // },
            ],
            createdRow: (row: Node, data: any) => {
                this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
                    const remarksContent = this.createRemarksContent(
                        data.call_remarks
                    );
                    const purposeContent = this.createPurposeContent(
                        data.purpose
                    );
                    // Combine both into one child row
                    const combinedContent = `
      <div>
      ${purposeContent}
      ${remarksContent}
      </div>
    `;
                    // Attach combined child content
                    const childRow = dtInstance
                        .row(row)
                        .child(combinedContent)
                        .show();
                });
            },
        };
    }

    /** Formats a Date as YYYY-MM-DD (local time) for the API */
    private formatDate(d: Date): string {
        return `${d.getFullYear()}-${(d.getMonth() + 1)
            .toString()
            .padStart(2, '0')}-${d.getDate().toString().padStart(2, '0')}`;
    }

    /** Sets the date filter (and the Download Excel range) to today */
    private setDateRangeToToday() {
        const today = this.formatDate(new Date());
        this.dates = { startDate: today, endDate: today };
        this.dateRangeValue = today + ' To ' + today;
        this.isshow = true;
    }

    /** Null-safe date/time cell renderer */
    renderDateTime(value: any): string {
        if (
            !value ||
            value === '0000-00-00 00:00:00' ||
            value === '0000-00-00 00:00'
        ) {
            return '--';
        }
        const formatted = this.datePipe.transform(
            value,
            'dd/MM/yyyy HH:mm',
            'UTC'
        );
        return formatted ? formatted : '--';
    }
    createPurposeContent(purpose: string | null | undefined): string {
        const safePurpose = purpose ? purpose : '--';
        const formattedPurpose = safePurpose.replace(/(.{150})/g, '$1<br/>');
        return `
    <tr class="purpose-row" style="padding-bottom: 20px;">
      <td colspan="9" style="word-break: break-word; white-space: normal;">
        <strong>Purpose:&nbsp;</strong>${formattedPurpose}
      </td>
    </tr><br/>`;
    }

    createRemarksContent(remarks: string | null | undefined): string {
        const safeRemarks = remarks ? remarks : '--';
        const formattedRemarks = safeRemarks.replace(/(.{150})/g, '$1<br/>');
        return `
    <tr class="remarks-row">
      <td colspan="9" style="word-break: break-word; white-space: normal;">
        <strong>Remarks:&nbsp;</strong>${formattedRemarks}
      </td>
    </tr>`;
    }
    // private formatChildRow(rowData: any): string {
    //   // console.log('rowdat',rowData)
    //   const childRowData = [];
    //   const parentRowData = [];
    //   childRowData.push(rowData);
    //   parentRowData.push(rowData);
    //   // event.preventDefault();
    //   // console.log("child row data",rowData);
    //   let childRowHtml = '<div style="display:flex">';
    //   childRowHtml += '<span><b>Remarks:</b></span>';

    //   if (childRowData.length > 0) {
    //     childRowData.forEach((row: any, index: number) => {
    //       const rowColor = index % 2 === 0 ? 'white' : '#F1F5F7';
    //       childRowHtml += '<div style="background-color:' + rowColor + '"></div>';
    //       childRowHtml += '<span class="ml-1">' + this.renderData(row.call_remarks) + '</span>';
    //     });
    //   } else {
    //     childRowHtml += '<span colspan="3">No Remarks Available</span>';
    //   }
    //   childRowHtml += '</div>';

    //   // console.log("myAnchor",checkbox)
    //   // checkbox.addEventListener('change')
    //   // console.log("document",childRowData)
    //   // console.log("document",childRowHtml)

    //   return childRowHtml;
    // }
    rerender(): void {
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.destroy();
            this.dtTrigger.next();
        });
    }
    ngAfterViewInit() {
        this.dtTrigger.next();
        // this.rerender2.listen('document', 'click', (event) => {

        //   if (event.target.classList.contains('expand-row')) {
        //     const iconElement = event.target as HTMLElement;
        //     const row = iconElement.closest('tr');
        //     if (row && this.dtElement && this.dtElement.dtInstance) {
        //       this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        //         const table = dtInstance;
        //         const tableRow = table.row(row);
        //         const rowData = tableRow.data();
        //         if (tableRow.child.isShown()) {
        //           // Collapse the row
        //           tableRow.child.hide();
        //           iconElement.classList.remove('mdi-minus');
        //           iconElement.classList.add('mdi-plus-circle');
        //         } else {
        //           // Expand the row
        //           tableRow.child(this.formatChildRow(rowData)).show();
        //           iconElement.classList.remove('mdi-plus-circle');
        //           iconElement.classList.add('mdi-minus');
        //         }
        //       });
        //     }
        //   }
        // });
    }
    selectedDate(value: any) {
        this.daterange.start = value.start;
        this.daterange.end = value.end;
        const formattedStartDate = this.formatDate(
            new Date(this.daterange.start)
        );
        const formattedEndDate = this.formatDate(new Date(this.daterange.end));
        this.dates = {
            endDate: formattedEndDate,
            startDate: formattedStartDate,
        };
        this.dateRangeValue = formattedStartDate + ' To ' + formattedEndDate;
        this.isshow = true;
        this.rerender();
    }
    Downlaod() {
        window.open(
            `${this.service.callReportExcel()}?startdate=${
                this.dates.startDate
            }&enddate=${this.dates.endDate}&isDailyCall=false`,
            '_blank'
        );
    }
    datechange() {
        let dateRange = document.getElementById('daterangeInput');
        if (dateRange) {
            dateRange.click();
        }
    }
    /** Reset clears the date filter entirely so the table shows all records */
    resetForm() {
        this.myGroup.reset();
        this.dates = undefined;
        this.dateRangeValue = null;
        this.isshow = false;
        // Calendar highlight goes back to today for the next time it is opened
        if (this.picker && this.picker.datePicker) {
            this.picker.datePicker.setStartDate(moment());
            this.picker.datePicker.setEndDate(moment());
        }
        this.rerender();
    }
    openDialog(): void {
        const dialogRef = this.dialog.open(AddCallAlertFormComponent, {
            width: '600px',
            autoFocus: false,
            maxHeight: '90vh',
            disableClose: true,
        });
        dialogRef.componentInstance.userId = this.userId;
        dialogRef.afterClosed().subscribe((result) => {
            if (result) {
                this.rerender();
            }
        });
    }
    close() {
        this.dialog.closeAll();
    }
    renderData(data) {
        if (
            data === '' ||
            data === null ||
            data === undefined ||
            data === 'null'
        ) {
            return '--';
        } else {
            return data;
        }
    }
}
